import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    inputWrapper: {
        display: "flex",
        gap: theme.spacing(2),
    },
}));
